import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import WOW from "wowjs";
import "animate.css";
import caringstaff from "../../Assets/Images/carring-staff-1.webp";
import securepayment from "../../Assets/Images/payment-1.webp";
import tourcustomization from "../../Assets/Images/custom-tour-1.webp";
import discountedprice from "../../Assets/Images/Price-beat-1.webp";
function HomeSection() {
  useEffect(() => {
    new WOW.WOW({
      live: false, // better performance
    }).init();
  }, []);
  return (
    <>
      {/* About Section */}
      <div className="container-fluid p-0 mt-5">
        <div className="bg-image d-flex align-items-center text-white">
          <div className="container position-relative">
            <div className="row justify-content-center justify-content-md-end">
              <div
                className="col-md-7 text-end m-3 p-3  rounded-3 shadow-sm wow animate__animated animate__slideInRight"
                data-wow-delay="0.5s"
                style={{ backgroundColor: "rgb(33 37 41 / 79%)" }}
              >
                <h2 className="fw-bold text-center display-5 mb-4">
                  About Haramayn Rooms
                </h2>
                <div className="">
                  <p className="lh-lg text-start p-2">
                    Haramayn Rooms is your trusted online platform for
                    discovering and booking the best hotels with ease. From
                    budget-friendly stays to premium properties, we make it
                    simple for travelers to compare options, find the right
                    match, and instantly book at competitive rates.
                  </p>

                  <p className="lh-lg text-start  p-2">
                    With a strong network of hotels across Makkah, Madinah, and
                    other key destinations, we focus on delivering convenience
                    and comfort for every traveler. Whether you’re planning a
                    short getaway, a family vacation, or a business trip, our
                    platform ensures a smooth booking experience tailored to
                    your needs.
                  </p>

                  <p className="lh-lg text-start p-2">
                    At Haramayn Rooms, we combine technology, reliability, and
                    customer support to give you peace of mind while planning
                    your journey. Our goal is to make travel stress-free,
                    accessible, and enjoyable—helping you focus on the moments
                    that matter most.
                  </p>
                  <div className="text-center p-2">
                    <NavLink
                      to="/about_us"
                      className="btn btn-primary"
                      style={{ textDecoration: "none" }}
                    >
                      Read More
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Book Us Section */}
      <div
        className="container-fluid  text-white py-5"
        style={{ backgroundColor: "#ae0a3b" }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* Title */}
            <div className="col-md-4 mb-3 mb-md-0 wow animate__animated animate__slideInLeft">
              <h3 className="fw-bold">Why Book With Us?</h3>
            </div>

            {/* Features */}
            <div className="col-md-8">
              <div className="d-flex flex-wrap justify-content-around text-center gap-4 ">
                <div className="wow animate__animated animate__fadeInUp">
                  <img src={caringstaff} alt="" />
                  <p className="fw-semibold">24/7 Customer Support</p>
                </div>
                <div className="wow animate__animated animate__fadeInUp">
                  <img src={securepayment} alt="" />
                  <p className="fw-semibold">Secure Payments</p>
                </div>
                <div className="wow animate__animated animate__fadeInUp">
                  <img src={tourcustomization} alt="" />
                  <p className="fw-semibold">Customized Tours</p>
                </div>
                <div className="wow animate__animated animate__fadeInUp">
                  <img src={discountedprice} alt="" />
                  <p className="fw-semibold">Discounted Prices</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeSection;
